<template>
  <page
    :back-to="getPreviousUrl"
    :title="$tc('wifi', 2)"
    size="is-desktop"
  >
    <div slot="page-header-right">
      <button class="button is-primary" @click="update()">
        <b-icon icon="content-save"></b-icon>
        <span>Update</span>
      </button>
    </div>
    <div class="card mb-6">
      <div class="card-content">
        <vendorForm ref="form" v-if="vendor.data" :vendor="vendor.data"></vendorForm>
      </div>
    </div>
  </page>
</template>

<script>
import VendorForm from './components/Form'

export default {
  components: {
    VendorForm,
  },
  data() {
    return {
      statusOptions: [
        {label: "All", value: "all"},
        {label: "Active", value: "active"}
      ],
      vendor: new window.RemoteData(
        () => `/admin/api/wifi/vendors/${this.$route.params.id}`
      ).load(),
    };
  },
  created() {
    if (!this.$route.query.status) {
      this.ignoreOnce = true;
    }
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  methods: {
    update(){
      this.$refs.form.submit();
    }
  }
}

</script>
